import { createContext, useCallback, useContext, useMemo, useRef } from 'react'

import { validateContext } from 'shared/utils'

const StateTriggerContext = createContext({})

export const useStateTrigger = () => validateContext(useContext(StateTriggerContext), {
  contextName: 'useStateTrigger',
  providerName: 'StateTriggerProvider'
})

export const StateTriggerProvider = ({ children }) => {
  const triggerFunctionsRef = useRef({})

  const registerTriggerFunction = useCallback((name, func) => {
    triggerFunctionsRef.current[name] = func
  }, [])

  const triggerFunction = useCallback((name, ...args) => {
    if (triggerFunctionsRef.current[name]) {
      triggerFunctionsRef.current[name](...args)
    } else {
      console.warn(`No trigger function registered with name: ${name}`)
    }
  }, [])

  const value = useMemo(() => ({
    triggerFunction,
    registerTriggerFunction
  }), [triggerFunction, registerTriggerFunction])

  return (
    <StateTriggerContext.Provider value={value}>
      {children}
    </StateTriggerContext.Provider>
  )
}
